import { render, staticRenderFns } from "./NewOrder.vue?vue&type=template&id=7501c5fa"
import script from "./NewOrder.vue?vue&type=script&lang=ts"
export * from "./NewOrder.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports